import { render, staticRenderFns } from "./FieldsetContractService.yaml?vue&type=template&id=5a3be2f3&component"
import script from "./FieldsetContractService.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractService.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports